import { Link } from 'react-router-dom';
import { useGameMode, modePath } from '../game/modeRouting';
import { modeLabel } from '@shared/chart';

/**
 * Friendly 404 - shown for any URL that doesn't match a known route. Provides
 * the user with three recovery options (mode picker, mode-specific home, and
 * mode-specific browse) so they're never stuck staring at a dead-end after a
 * typo or stale link. The mode-specific links honour wherever the player was
 * last (URL or saved preference) so they don't lose their current mode
 * context just because a link 404'd.
 */
export function NotFoundPage() {
  const mode = useGameMode();
  const label = modeLabel(mode);
  return (
    <div className="loading-screen" data-testid="not-found-page">
      <h2>Lost in the grid</h2>
      <p className="muted">
        That page does not exist - probably an old link or a typo in the URL.
      </p>
      <div className="home-cta" style={{ marginTop: '1.5rem' }}>
        <Link to="/" className="btn btn-primary">
          Pick a mode
        </Link>
        <Link to={modePath(mode)} className="btn">
          {label} home
        </Link>
        <Link to={modePath(mode, 'browse')} className="btn btn-ghost">
          Browse {label}
        </Link>
      </div>
    </div>
  );
}
